import styled, { useTheme } from 'styled-components';
import {
  BodyLarge,
  ButtonMediumSemiText,
  Heading1Text,
  Heading2Text,
} from '../../../../components/Texts';
import Button from '../../../../components/Button';
import WidthContainer from '../../../../components/WidthContainer';
import {
  PHONE_MEDIA_QUERY,
  useMediaQuery,
} from '../../../../common/responsive';
import ColorizedSpan from '../../../../components/Colorized';
import { createMailtoLink } from '../../../../common/email';
import { useSelector } from 'react-redux';
import { selectThemeMode } from '../../../../redux/slices/themeSlice';
import { useNavigate } from 'react-router-dom';
import { hapticsImpactLight } from '../../../../common/haptic';

const InnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin: 10px 0px;
`;

const OutContainer = styled.div`
  min-height: 600px;
  padding-top: 120px;
  padding-bottom: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  position: relative;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: row;
    gap: 10px;
  }
`;

const ItemContainer = styled.div`
  padding: 16px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.border.primary};
  display: flex;
  flex-direction: row;
  color: ${({ theme }) => theme.text.regular};
  gap: 12px;
`;

const MainImage = styled.img`
  width: 90%;
`;

const PreTitle = styled.div`
  background-color: ${({ theme, isDark }) =>
    isDark ? theme.primary.background : theme.primary.ultraLight};
  padding: 12px;
  border-radius: 16px;
  width: fit-content;
  color: ${({ theme }) => theme.primary.primary};
  border: 1px solid ${({ theme }) => theme.primary.primary};
  margin-bottom: 40px;
  @media ${PHONE_MEDIA_QUERY} {
    text-align: center;
  }
`;

const GetStarted = () => {
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  const selectedTheme = useSelector(selectThemeMode);
  const theme = useTheme();

  const navigate = useNavigate();

  return (
    <>
      <WidthContainer>
        <OutContainer>
          <PreTitle id='partners' isDark={selectedTheme === 'dark'}>
            <ButtonMediumSemiText style={{ color: theme.text.title }}>
              Need a better way to put your token in front of real people?
            </ButtonMediumSemiText>
          </PreTitle>
          <Container>
            <div
              style={{
                display: 'flex',
                gap: 24,
                maxWidth: 580,
                flexDirection: 'column',
                width: '100%',
                marginBottom: isMobile ? '30px' : '0px',
              }}
            >
              <HeaderContainer>
                <Heading2Text
                  style={{
                    color: theme.text.title,
                    width: '100%',
                  }}
                >
                  Get Your Physical <br />
                  <ColorizedSpan>Gift Cards</ColorizedSpan>
                </Heading2Text>
              </HeaderContainer>
              <div
                style={{
                  display: 'flex',
                  gap: 16,
                  flexDirection: 'column',
                  width: '100%',
                }}
              >
                <ItemContainer>
                  <img src='/landing-v2/price.webp' width={24} height={24} />
                  <BodyLarge>$1 per printed gift card</BodyLarge>
                </ItemContainer>
                <ItemContainer>
                  <img src='/landing-v2/design.webp' width={24} height={24} />
                  <BodyLarge>Custom designs</BodyLarge>
                </ItemContainer>
                <ItemContainer>
                  <img src='/landing-v2/global.webp' width={24} height={24} />
                  <BodyLarge>Ships worldwide</BodyLarge>
                </ItemContainer>
              </div>
              <Button
                fullWidth={isMobile}
                onClick={() => {
                  hapticsImpactLight();
                  navigate('/gift-cards');
                }}
              >
                ORDER NOW
              </Button>
            </div>
            <InnerContainer style={{ alignItems: 'flex-end' }}>
              <MainImage src='/landing-v2/physical.webp' />
            </InnerContainer>
          </Container>
        </OutContainer>
      </WidthContainer>
    </>
  );
};

export default GetStarted;
